const mutations = {
  setUser(state, payload) {
    state.user = payload;
  },
  setUserData(state, payload) {
    state.userData = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setLoggedIn(state, payload) {
    state.loggedIn = payload;
  },
  setAdminToken(state, payload) {
    state.adminToken = payload;
  },
  setEmailChecked(state, payload) {
    state.emailChecked = payload;
  },
  setLoginDialog(state, payload) {
    state.loginDialog = payload;
  },
  toggleLogin(state){
    state.loginDialog = !state.loginDialog
  },
  toggleRegister(state){
    state.registerDialog = !state.registerDialog
  },
  toggleForgot(state){
    state.forgotDialog = !state.forgotDialog
  },
  openFeedbackModal(state){
    state.feedbackModal = !state.feedbackModal
  },
  setFeedback(state, payload){
    state.feedback = {
      show: payload.show,
      message: payload.message,
      btnTxt: payload.btnTxt,
      color: payload.color,
      textColor: payload.textColor
    }
  },
  toggleLoadingPage(state){
    state.loadingPage = !state.loadingPage
  },
  toggleGoLive(state){
    state.video.golive = !state.video.golive
  },
  setGoLive(state, payload){
    state.video.golive = payload
  },
  setVideo(state, payload) {
    state.video = payload
  },
  setVideos(state, payload) {
    state.videos = payload
  },
};

export default mutations;